import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../style';
import { useHistory } from 'react-router-dom';
import { TextWithImages } from '../TextWithImages';
import { DoubleButton } from '../DoubleButton';

const useLocalStyles = makeStyles(theme => ({
  thirdStepContainer: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  thirdStepCol: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important'
    },
    marginRight: '1em'
  }
}));

const GRAPHS_DOWNLOAD_URL =
  'https://appsource.microsoft.com/en-us/product/office/WA200001574?tab=Overview)';
const SOLVERS_DOWNLOAD_URL =
  'https://appsource.microsoft.com/en-us/product/office/WA200001864?tab=Overview)';

export const Features = () => {
  const { t } = useTranslation('documentation');
  const classes = useStyles();
  const localClasses = useLocalStyles();
  const history = useHistory();

  return (
    <TextWithImages
      src={'/images/views/documentation/general/Access-to-features-SOLVERS.gif'}
      alt={t('general.features.header')}>
      <h3 className="desc-title no-margin-padding">
        {t('general.features.title')}
      </h3>
      <p>{t('general.features.subtitle')}</p>
      <h3 style={{ marginTop: '2em' }}>
        {t('general.features.firstStep.title')}
      </h3>
      <p className="mt-4">{t('general.features.firstStep.content')}</p>
      <DoubleButton
        onClick1={() => window.open(SOLVERS_DOWNLOAD_URL)}
        onClick2={() => window.open(GRAPHS_DOWNLOAD_URL)}
        content1={t('general.features.firstStep.downloadSolvers')}
        content2={t('general.features.firstStep.downloadGraphs')}
      />
      <h3 className="mt-10">{t('general.features.secondStep.title')}</h3>
      <p className="mt-4">{t('general.features.secondStep.content')}</p>
      <DoubleButton
        onClick1={() => history.push('/pricing/trial')}
        onClick2={() => history.push('/pricing')}
        content1={t('general.features.secondStep.free')}
        content2={t('general.features.secondStep.subscription')}
      />
      <h3 className="mt-10">{t('general.features.thirdStep.title')}</h3>
      <p>{t('general.features.thirdStep.content')}</p>
      <div className={localClasses.thirdStepContainer}>
        <div
          className={clsx(
            classes.textSectionWrapper,
            localClasses.thirdStepCol
          )}>
          <h3 className="mt-10">QuickCells Solvers</h3>
          <p>{t('general.features.thirdStep.solvers')}</p>
        </div>
        <div
          className={clsx(
            classes.textSectionWrapper,
            localClasses.thirdStepCol
          )}>
          <h3 className="mt-10">QuickCells Graphs</h3>
          <p>{t('general.features.thirdStep.graphs')}</p>
        </div>
      </div>
    </TextWithImages>
  );
};
